import api from '@src/api';

// Fetch constellations
export const fetchConstellations = async () => {
  let response = await api.imageSearch.get('/satellites');
  return response.data;
};
export const FetchSatelliteInfo = async id => {
  let response = await api.imageSearch.get(`/satellites/${id}`);
  // console.log('lens satellite response: ', response.data);
  return response.data;
};

export const FetchImages = async (_, { arg }) => {
  let response = await api.imageSearch.post('/search', arg);
  // console.log("lens response: ", response.data);
  return response.data;
};
